export { default } from "./ProjectPricingV2Mspa";
